import { createContext, useContext, useState } from "react";

interface LoginActions {
  showLoginModal: boolean;
  showSignup: boolean;
  toggleLoginModal: () => void;
  toggleSignupModal: (value:boolean) => void;
}

export const LoginProviderContext = createContext<LoginActions>({
  showLoginModal: false,
  showSignup: false,
  toggleLoginModal: () => {},
  toggleSignupModal: () => {},
});

export const LoginContextProvider = ({ children }) => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showSignup, setShowSignup] = useState(false);

  const toggleLoginModal = () => {
    setShowLoginModal(!showLoginModal);
  };

  const toggleSignupModal = (value:boolean) => {
    setShowSignup(value);
  };

  return (
    <LoginProviderContext.Provider
      value={{
        showLoginModal,
        showSignup,
        toggleLoginModal,
        toggleSignupModal,
      }}
    >
      {children}
    </LoginProviderContext.Provider>
  );

};

export const useLogin = (): LoginActions => useContext(LoginProviderContext);
